import React, {ReactElement} from 'react';
import NumberFormat from 'react-number-format';
import HelperUtils from '@shared/utils/HelperUtils';

interface CurrencyFormatProps {
  value?: string | number;
  displayType?: any;
  thousandSeparator?: boolean;
  prefix?: string;
  // applies to negative values, should show negative sign, -2, or brackets, (2)
  // if useSign is true, negative value shows as -x, else as (x)
  useSign?: boolean;
  // to round the value to dollar place or 2 decimals
  // ignoreRound is true, then value is rounded and fixed to 2 decimals, else nearest dollar
  ignoreRound?: boolean;
}

export const getFormattedValue = (
  value: any,
  ignoreRound?: boolean
  // useSign?: boolean
): number => {
  let fValue = value;
  // value has to be a number
  if (!isNaN(fValue)) {
    // fix to 2 decimals if rounding is ignored
    if (ignoreRound) {
      fValue = HelperUtils.fixTo2Decimals(fValue);
    } else {
      fValue = Math.round(fValue);
    }
  }
  return fValue;
};

const CurrencyFormatter = (props: CurrencyFormatProps): ReactElement => {
  return (
    <NumberFormat
      value={getFormattedValue(props?.value, props?.ignoreRound)}
      displayType={props?.displayType || 'text'}
      thousandSeparator={props?.thousandSeparator}
      prefix={props?.prefix}
    />
  );
};

export default CurrencyFormatter;
